import { colors } from "@mui/material";

const colorConfigs = {
  sidebar: {
    bg: "#2f3436",
    color: "#B8C7CE",
    hoverBg: " #2b3032",
    activeBg: "#2b3032"
  },
  topbar: {
    bg: "#fff",
    color: "#000"
  },
  mainBg: colors.grey["100"]
};

export default colorConfigs;